'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofMask = require('../dof-mask');

var _dofMask2 = _interopRequireDefault(_dofMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icon = require('../setting/icon.base64.js'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CHECKED = icon['radio_checked'];
var dom = weex.requireModule('dom');
var animation = weex.requireModule('animation');
exports.default = {
  components: { DofMask: _dofMask2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '请选择'
    },
    items: {
      type: Array
    },
    index: {
      type: [String, Number],
      default: null
    },
    keyField: {
      type: String,
      default: 'key'
    },
    valueField: {
      type: [String, Array],
      default: 'value'
    },
    button: {
      type: String,
      default: '取消'
    },
    rows: {
      type: Number,
      default: 5
    },
    hideOnMask: {
      type: Boolean,
      default: true
    },
    // 新加的参数是否显示图标
    isShowIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    height: function height() {
      var rows = this.rows > 9 ? 9 : this.rows;
      rows = rows < 2 ? 2 : rows;
      var len = rows * 90 + 88;
      return len;
    },
    radioIcon: function radioIcon() {
      return CHECKED;
    }
  },
  watch: {
    show: function show(value) {
      var _this2 = this;

      if (value) {
        this.$nextTick(function (e) {
          console.log(e);
          if (_this2.index && _this2.index >= 0) {
            var elName = 'item' + _this2.index;
            var el = _this2.$refs[elName][0];
            // 滚动至选中值，并调整至中间
            dom.scrollToElement(el, { offset: -_this2.height / 2 + 45 + 15 });
          }
          _this2.open();
        });
      }
    }
  },
  methods: {
    color: function color(item, i) {
      return item.disabled ? '#b4b6cb' : this.index === i ? '#00A4F2' : '#020f13';
    },
    display: function display(item) {
      var result = '';
      if (typeof this.valueField === 'string') {
        result = item[this.valueField];
      } else if (Array.isArray(this.valueField)) {
        for (var index = 0; index < this.valueField.length; index++) {
          var field = this.valueField[index];
          result += item[field] || field || '';
        }
      }
      return result;
    },

    animationFn: function animationFn(el, translate, timing, fn) {
      animation.transition(el, {
        styles: {
          transform: translate,
          transformOrigin: 'center center'
        },
        duration: 200, // ms
        timingFunction: timing,
        delay: 0 // ms
      }, function () {
        fn && fn();
      });
    },
    // 打开上拉菜单
    open: function open() {
      var _this = this;
      var el = _this.$refs.radiogroupBox;
      var translate = 'translate(0px, -' + _this.height + 'px, 0px)';
      _this.animationFn(el, translate, 'ease-in');
    },
    // 点击mask遮罩层
    layoutClick: function layoutClick() {
      if (!this.hideOnMask) return;

      var _this = this;
      var el = this.$refs.radiogroupBox;
      var translate = 'translate(0px, ' + _this.height + 'px, 0px)';
      _this.animationFn(el, translate, 'ease-in', function () {
        _this.show = false;
        _this.$emit('close');
      });
    },
    // 点击取消
    cancelClick: function cancelClick() {
      var _this = this;
      var el = this.$refs.radiogroupBox;
      var translate = 'translate(0px, ' + _this.height + 'px, 0px)';
      _this.animationFn(el, translate, 'ease-in', function () {
        _this.show = false;
        _this.$emit('close');
      });
    },

    // 确定选择
    confirmClick: function confirmClick() {
      var items = this.items,
          index = this.index,
          keyField = this.keyField;

      if (items[index].disabled) return;

      var _this = this;
      var el = this.$refs.radiogroupBox;
      var translate = 'translate(0px, ' + _this.height + 'px, 0px)';
      _this.animationFn(el, translate, 'ease-in', function () {
        _this.show = false;
        _this.$emit('itemClick', { item: items[index], index: index, keyField: keyField });
        _this.$emit('close');
      });
    },

    // 菜单项点击事件
    radiogroupItemClick: function radiogroupItemClick(item, index, key) {
      if (item.disabled) return;

      var _this = this;
      var el = this.$refs.radiogroupBox;
      var translate = 'translate(0px, ' + _this.height + 'px, 0px)';
      _this.animationFn(el, translate, 'ease-in', function () {
        _this.show = false;
        _this.$emit('itemClick', { item: item, index: index, key: key });
        _this.$emit('close');
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-select/index.vue
// module id = 383
// module chunks = 0 1